import { Color } from "../enums/Color"

export const profileEntrance = {
    mobile: {  
        userAvatar: {
            height: "13.05vw",
            width: "13.05vw",
            border: "1.38vw solid " + Color.Green,
            borderRadius: "50%", 
            objectFit: "cover",                       
            marginRight: "4.16vw"
        },
        dropdownLabel: {
            position: "relative" as "relative",
            textDecoration: "none",
            fontSize: "4.4vw",
            fontWeight: "medium",
            letterSpacing: "0px",
            color: Color.MiddleBlack,
            cursor: "pointer",
            opacity: "1"
        },
        userWrapper: {
            marginLeft: "auto",
            marginTop: "3%"
        }, 
        userDropdown: {                        
            wrapper: {
                position: "relative" as "relative",
                textAlign: "-webkit-center" as "-webkit-center"
            },        
            button: {
                backgroundColor: "transparent",
                color: Color.LightAsh,
                fontSize: "4.34vw",                
                fontWeight: "bold" as "bold",
                border: "none",
                cursor: "pointer"
            },
            item: {
                paddingLeft: "1.38vw",
                paddingRight: "1.38vw",
                textAlign: "left"
            },            
            labelWrapper: {        
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center" as "center"
            },
            labelIcon: {
                width: "4.16vw",
                height: "4.16vw",
                fill: Color.LightAsh,                
                marginLeft: "2.77vw",
                transition: "transform 0.1s linear",
                hover: {
                    transform: "rotate(180deg)"
                }
            },
            label: {                             
                textDecoration: "none",       
                letterSpacing: "0px",                
                color: Color.LightAsh,
                opacity: "1" 
            },
            leave: {
                display: "none"            
            },
            hover: {                
                display: "block",
                width: "48.8vw",
                marginTop: "2.70vh",
                marginBottom: "2.70vh",
                padding: "1.38vw", 
                fontSize: "4vw",                           
                backgroundColor: Color.White,            
                boxShadow: "0 0.8vw 2.77vw rgb(0 0 0 / 0.5)",
                borderRadius: "2.77vw",
                zIndex: 2
            },
            bottomBorder: {
                border: 0,
                height: "1px",
                width: "92%",
                background: Color.MiddleAsh,
                margin: "0 auto",
                zIndex: "1"
            },
            hoveredBorder: {
                background: Color.White,
                borderRadius: "1px"
            }
        },
        dropdownItem: {
            color: Color.MiddleBlack,
            fontWeight: "500",
            hover: {
                backgroundColor: Color.Blue,
                padding: "1.38vw",
                borderRadius: "1.94vw",
                color: Color.White
            },
            leave: {
                backgroundColor: Color.White,
                padding: "1.38vw"
            }
        },
        logoutDropdownItem: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            hover: {
                fill: Color.White,
                backgroundColor: Color.Blue,
                padding: "1.38vw",
                borderRadius: "1.94vw",
                color: Color.White
            },
            leave: {
                fill: Color.Red,
                backgroundColor: Color.White,
                padding: "1.38vw"
            }
        },
        logoutDropdownLabel: {
            color: Color.Red
        },
        logoutIcon: {
            float: "right"
        }
    },
    desktop: {    
        dropdownLabel: {
            fontSize: "0.937vw"
        },
        logoutIcon: {
            width: "0.67vw",
            height: "0.572vw"
        },
        logoutDropdownItem: {
            hover: {              
                borderRadius: "0.4vw",
                padding: "0.36vw"
            },
            leave: {
                padding: "0.36vw"
            }
        },
        dropdownItem: {
            fontSize: "0.83vw",         
            hover: {
                borderRadius: "0.36vw",
                padding: "0.31vw 0.52vw"
            },
            leave: {
                padding: "0.31vw 0.52vw"
            }
        },
        userWrapper: {
            display: "flex",
            flexDirection: "row" as "row",
            marginLeft: "unset",
            marginTop: "unset"
        },
        userDropdown: {
            wrapper: {
                display: "inline-block"
            },
            button: {
                fontSize: "1.17vw",
                fontWeight: 500
            },
            item: {
                padding: "0"
            },
            labelIcon: {
                width: "1.09vw",
                height: "1.09vw",
                marginLeft: "1.35vh"
            },
            label: {
                fontSize: "1.17vw"
            },
            hover: {
                position: "absolute" as "absolute",
                width: "22vh",
                height: "auto",
                padding: "0.6vw",
                right: 0,
                marginTop: "unset",
                boxShadow: "0 0.2vw 1.35vh rgb(0 0 0 / 0.5)",
                borderRadius: "1.35vh",
                zIndex: 3
            }
        },
        userAvatar: {
            height: "3.66vw",
            width: "3.66vw",
            cursor: "pointer",
            marginRight: "unset"
        },
        userName: {
            display: "none"
        },
        recruiterUserAvatar: {
            border: "0.5vw solid " + Color.DeepBlack,
        },
        candidateUserAvatar: {
            border: "0.5vw solid " + Color.Green,
        },
        recruiterLabelIcon: {
            width: "1.61vw",
            height: "1.87vw",
            fill: Color.DeepBlack,
            marginLeft: "1.35vh"
        }
    }
}